import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import { Col, Nav, Row } from 'react-bootstrap'

function WinPercentageWidget({ data, matchDetail }) {
  const [activeTab, setActiveTab] = React.useState('View')
  const oddData = matchDetail?.odds?.allOdds || matchDetail?.odds?.favOdds
  console.log(oddData, matchDetail)

  const teamAPercentage = data?.[0]?.sWinPercentage
  const teamBPercentage = data?.[1]?.sWinPercentage
  const tiePercentage = data?.[2]?.sWinPercentage

  const handleMatchFilter = value => {
    setActiveTab(value)
  }

  if (teamAPercentage && teamBPercentage && teamAPercentage > 0 && teamBPercentage > 0) {
    return (
      <div className="common-box ">
        <div className={styles.title}>Probability</div>
        <Nav className={`${styles.navTab} text-uppercase equal-width-nav mb-3`} variant="pills">
          <Nav.Item>
            <Nav.Link className={`${activeTab === 'View' && 'active'} nav-link`} onClick={() => handleMatchFilter('View')}>
              %View
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className={`${activeTab === 'Odds' && 'active'} nav-link`} onClick={() => handleMatchFilter('Odds')}>
              Odds View
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {activeTab === 'View' && (
          <>
            <div className="d-flex justify-content-between">
              <div className={`${styles.teamName} text-start`} style={{ width: `${teamAPercentage}%` }}>
                <div>{data[0]?.sTitle}</div>
                <div className={styles.percentage} style={{ color: '#F25724' }}>{`${teamAPercentage}%`}</div>
              </div>
              {tiePercentage > 0 && (
                <div className={`${styles.teamName} text-center`} style={{ width: `${tiePercentage}%` }}>
                  <div>Draw</div>
                  <div className={styles.percentage} style={{ color: '#B5BAC2' }}>{`${tiePercentage}%`}</div>
                </div>
              )}
              <div className={`${styles.teamName} text-end`} style={{ width: `${teamBPercentage}%` }}>
                <div>{data[1]?.sTitle}</div>
                <div className={`${styles.percentage} ${styles.colorBlue}`}>{`${teamBPercentage}%`}</div>
              </div>
            </div>
            <div className="d-flex">
              <div className={styles.bar} style={{ width: `${teamAPercentage}%`, background: '#F25724' }}>
                {' '}
              </div>
              <div className={styles.bar} style={{ width: `${tiePercentage}%`, background: '#B5BAC2' }}>
                {' '}
              </div>
              <div className={`${styles.bar} ${styles.brBlue}`} style={{ width: `${teamBPercentage}%` }}>
                {' '}
              </div>
            </div>
          </>
        )}

        {activeTab === 'Odds' && (
          <>
            {oddData?.length > 0 && (
              <Col xl={12}>
                <Row className="gy-2">
                  {oddData?.map((outcome, index) => {
                    return outcome?.title ? (
                      <Col key={index} xl={index < 2 ? 6 : 12}>
                        <div className="d-flex flex-column align-items-center">
                          <p className="mb-1 fw-bold">{outcome?.title}</p>
                          <div className="d-flex justify-content-between gap-1">
                            <div className="bg-success p-1 rounded-2 text-center text-white" style={{ minWidth: '40px' }}>
                              {outcome?.back ? Number(outcome.back).toFixed(2) : '-'}
                            </div>
                            <div className="bg-danger p-1 rounded-2 text-center text-white" style={{ minWidth: '40px' }}>
                              {/* Optionally some other stat or replicate odds */}
                              {outcome?.lay ? Number(outcome?.lay).toFixed(2) : '-'}
                            </div>
                          </div>
                        </div>
                      </Col>
                    ) : null
                  })}
                </Row>
              </Col>
            )}
            {oddData?.title && (
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-t-origin  font-medium self-center pe-3 whitespace-nowrap">{oddData?.title}</div>
                <div className="d-flex gap-1">
                  {oddData?.back ? (
                    <div className="bg-success p-1 rounded-2 text-center text-white" style={{ minWidth: '40px' }}>
                      {/* <UpArrow /> */}
                      {oddData?.back}
                    </div>
                  ) : null}
                  {oddData?.lay ? (
                    <div className="bg-danger p-1 rounded-2 text-center text-white" style={{ minWidth: '40px' }}>
                      {/* <DownArrow /> */}
                      {oddData?.lay}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    )
  } else {
    return ''
  }
}
WinPercentageWidget.propTypes = {
  data: PropTypes.any,
  matchDetail: PropTypes.object
}
export default WinPercentageWidget
